import { IDefaultContextType } from "./context.types";

export const DefaultContext: IDefaultContextType = {
  state: {},
  actions: {},
};
